module.exports = __webpack_public_path__ + "img/mostrador.81231f30.png";